import React from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import './PBQuot.css';
import assets from '../assets/images';

const PBQuot = React.forwardRef(({ formData, balance, handlePrint }, ref) => {
  const generatePDF = () => {
    const input = document.getElementById('luxury-quotation');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });

    html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
      letterRendering: true,
      width: 210, // A4 width in mm
      height: 297 // A4 height in mm
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', 0, 0, 210, 297);
      pdf.save(`Quotation_${formData.quotationNumber || 'PB0030001'}.pdf`);
    });
  };

  const subtotal = Number(formData.total || 0) - Number(formData.discount || 0);

  // Check if preshoot data exists
  const hasPreshootData = formData.preshootDate || formData.preshootLocation;
  // Check if homecoming data exists
  const hasHomecomingData = formData.homecomingDate || formData.homecomingLocation;
  // Check if any package options are selected
  const hasPackageOptions = Object.values(formData.packageOptions || {}).some(selected => selected);
  // Check if any photography services are selected
  const hasPhotographyServices = formData.photographySetup?.camera1 || formData.photographySetup?.camera2;
  // Check if any cinematography services are selected
  const hasCinematographyServices = formData.cinematographySetup?.camera1 || 
                                  formData.cinematographySetup?.camera2 || 
                                  formData.cinematographySetup?.drone;
  // Check if any preshoot services are selected
  const hasPreshootServices = formData.preshootSetup?.camera1 || 
                             formData.preshootSetup?.camera2 || 
                             formData.preshootSetup?.drone;
  // Check if any homecoming options are selected
  const hasHomecomingOptions = formData.homecomingOptions?.shootOnly || formData.homecomingOptions?.shootFunction;
  // Check if there are any additional notes
  const hasAdditionalNotes = formData.additionalDetails;
  // Check if there are any payments
  const hasPayments = formData.payments?.some(p => p.amount) || formData.advance;

  return (
    <div className="luxury-container">
      <div className="luxury-quotation" ref={ref} id="luxury-quotation">
        {/* Luxury Header with Gold Accents */}
        <div className="luxury-header">
          <div className="header-left">
            <div className="logo-section">
              <img src={assets.main_logo} alt="Logo" className="luxury-logo" />
              <div className="luxury-meta">
                <p><span>Quotation No:</span> {formData.quotationNumber || 'PB0030001'}  &nbsp;||&nbsp;  <span>Date:</span> {new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <div className="luxury-contacts">
              <p>
                <svg className="icon" viewBox="0 0 24 24" width="16" height="16">
                  <path fill="#b89f7b" d="M20 22.621l-3.521-6.795c-.008.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.083-1.026-3.493-6.817-2.106 1.039c-7.202 3.755 4.233 25.982 11.6 22.615.121-.055 2.102-1.029 2.11-1.033z"/>
                </svg>
                0714 313 131 / 0113 175 111
              </p>
              <p>
                <svg className="icon" viewBox="0 0 24 24" width="16" height="16">
                  <path fill="#b89f7b" d="M12 12.713l-11.985-9.713h23.97l-11.985 9.713zm0 2.574l-12-9.725v15.438h24v-15.438l-12 9.725z"/>
                </svg>
                info@priyanthabandara.lk
              </p>
              <p>
                <svg className="icon" viewBox="0 0 24 24" width="16" height="16">
                  <path fill="#b89f7b" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm7.931 9h-2.764a14.67 14.67 0 0 0-1.792-4.644A8.013 8.013 0 0 1 19.931 11zM12 4.93c1.167 1.491 2.007 3.885 2.21 6.07H9.79c.203-2.185 1.043-4.579 2.21-6.07zM4.069 13h2.764a14.67 14.67 0 0 0 1.792 4.644A8.013 8.013 0 0 1 4.069 13zm2.764-2H4.069a8.013 8.013 0 0 1 4.556-4.644A14.67 14.67 0 0 0 6.833 11zM12 19.07c-1.167-1.491-2.007-3.885-2.21-6.07h4.42c-.203 2.185-1.043 4.579-2.21 6.07zm3.387-.644A14.67 14.67 0 0 0 17.167 13h2.764a8.013 8.013 0 0 1-4.556 4.426z"/>
                </svg>
                www.priyanthabandara.lk
              </p>
              <p>
                <svg className="icon" viewBox="0 0 24 24" width="16" height="16">
                  <path fill="#b89f7b" d="M12 2c3.196 0 6 2.618 6 5.602 0 3.093-2.493 7.132-6 12.661-3.507-5.529-6-9.568-6-12.661 0-2.984 2.804-5.602 6-5.602m0-2c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"/>
                </svg>
                96 Moratuwa Road, Piliyandala, Sri Lanka
              </p>
            </div>
          </div>
        </div>

        {/* Client & Event Info - Side by Side */}
        <div className="luxury-dual-section">
          <div className="luxury-client">
            <h3 className="section-title1">CLIENT DETAILS</h3>
            <div className="luxury-info-grid">
              <div className="info-item">
                <span>Name</span>
                <p>{formData.customerName || '_________'}</p>
              </div>
              <div className="info-item">
                <span>Address</span>
                <p>{formData.address || '_________'}</p>
              </div>
              <div className="info-item">
                <span>Contact</span>
                <p>{formData.telephoneNo || '_________'}</p>
              </div>
              <div className="info-item">
                <span>Mobile</span>
                <p>{formData.mobileNo || '_________'}</p>
              </div>
              {formData.email && (
                <div className="info-item">
                  <span>Email</span>
                  <p>{formData.email}</p>
                </div>
              )}
            </div>
          </div>

          <div className="luxury-event">
            <h3 className="section-title1">EVENT DETAILS</h3>
            <div className="luxury-event-grid">
              <div className="event-item">
                <span>Wedding</span>
                <p>
                  {formData.weddingDate || '_________'} 
                  {formData.WeddingLocation && <><br />at {formData.WeddingLocation}</>}
                </p>
              </div>
              {hasPreshootData && (
                <div className="event-item">
                  <span>Preshoot</span>
                  <p>
                    {formData.preshootDate || '_________'} 
                    {formData.preshootLocation && <><br />at {formData.preshootLocation}</>}
                  </p>
                </div>
              )}
              {hasHomecomingData && (
                <div className="event-item">
                  <span>Homecoming</span>
                  <p>
                    {formData.homecomingDate || '_________'} 
                    {formData.homecomingLocation && <><br />at {formData.homecomingLocation}</>}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Package & Services - Elegant Layout */}
        <div className="luxury-package-section">
          {(formData.packageSelected || hasPackageOptions) && (
            <div className="luxury-package">
              <h3 className="section-title1">SELECTED PACKAGE</h3>
              <div className="package-header">
                <h4>{formData.packageSelected || 'Premium Package'}</h4>
              </div>
              {hasPackageOptions && (
                <ul className="luxury-features">
                  {Object.entries(formData.packageOptions || {})
                    .filter(([_, selected]) => selected)
                    .map(([option], index) => (
                      <li key={index}>
                        <span className="feature-check">✓</span>
                        <span className="feature-text">{option}</span>
                      </li>
                    ))}
                </ul>
              )}
            </div>
          )}

          {(hasPhotographyServices || hasCinematographyServices || hasPreshootServices || hasHomecomingOptions) && (
            <div className="luxury-services">
              <h3 className="section-title1">SERVICES INCLUDED</h3>
              <div className="services-grid">
                {hasPhotographyServices && (
                  <div className="service-category">
                    <h4>Photography</h4>
                    <ul>
                      {formData.photographySetup?.camera1 && <li>1 Camera coverage</li>}
                      {formData.photographySetup?.camera2 && <li>2 Cameras coverage</li>}
                    </ul>
                  </div>
                )}
                {hasCinematographyServices && (
                  <div className="service-category">
                    <h4>Cinematography</h4>
                    <ul>
                      {formData.cinematographySetup?.camera1 && <li>1 Camera coverage</li>}
                      {formData.cinematographySetup?.camera2 && <li>2 Cameras coverage</li>}
                      {formData.cinematographySetup?.drone && <li>Drone</li>}
                    </ul>
                  </div>
                )}
                {hasPreshootServices && (
                  <div className="service-category">
                    <h4>Preshoot</h4>
                    <ul>
                      {formData.preshootSetup?.camera1 && <li>1 Camera coverage</li>}
                      {formData.preshootSetup?.camera2 && <li>2 Cameras coverage</li>}
                      {formData.preshootSetup?.drone && <li>Drone</li>}
                    </ul>
                  </div>
                )}
                {hasHomecomingOptions && (
                  <div className="service-category">
                    <h4>Homecoming</h4>
                    <ul>
                      {formData.homecomingOptions?.shootOnly && <li>Shoot Only</li>}
                      {formData.homecomingOptions?.shootFunction && <li>Shoot & Function</li>}
                    </ul>
                  </div>
                )}
              </div>
              {hasAdditionalNotes && (
                <>
                  <h4 className="additional-note-h4">Additional Notes</h4>
                  <span className="additional-note">{formData.additionalDetails}</span>
                </>
              )}
            </div>
          )}
        </div>

        {/* Payment Summary - Luxury Table */}
       <div className="luxury-payment-summary">
          <h3 className="section-title1 payment">PAYMENT SUMMARY</h3>
          <div className="payment-table">
            <div className="payment-row header">
              <div className="col-description">Description</div>
              <div className="col-amount">Amount (LKR)</div>
            </div>
            
            <div className="payment-row">
              <div className="col-description">Package Value</div>
              <div className="col-amount">{Number(formData.total || 0).toLocaleString('en-US', {minimumFractionDigits: 2})}</div>
            </div>
            
            {formData.discount && (
              <div className="payment-row discount">
                <div className="col-description">Discount</div>
                <div className="col-amount">- {Number(formData.discount || 0).toLocaleString('en-US', {minimumFractionDigits: 2})}</div>
              </div>
            )}
            
            <div className="payment-row subtotal">
              <div className="col-description">Subtotal</div>
              <div className="col-amount">{subtotal.toLocaleString('en-US', {minimumFractionDigits: 2})}</div>
            </div>
            
            {formData.advance && (
  <div className="payment-row">
    <div className="col-description">
      Advance Payment
      {formData.advanceDate && (
        <span className="payment-date">
          (Payment Date: {new Date(formData.advanceDate).toLocaleDateString('en-US', { 
            day: 'numeric', 
            month: 'short',
            year: 'numeric'
          })})
        </span>
      )}
    </div>
    <div className="col-amount">
      - {Number(formData.advance || 0).toLocaleString('en-US', {minimumFractionDigits: 2})}
    </div>
  </div>
)}
            
            {formData.payments?.filter(p => p.amount).length > 0 && (
              <>
                {formData.payments
                  .filter(payment => payment.amount)
                  .map((payment, index) => (
                    <div key={index} className="payment-row">
                      <div className="col-description">
                        {payment.description || `Payment ${index + 1}`}
                        {payment.date && (
                          <span className="payment-date">
                            (Payment Date: {new Date(payment.date).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })})
                          </span>
                        )}
                      </div>
                      <div className="col-amount">- {Number(payment.amount || 0).toLocaleString('en-US', {minimumFractionDigits: 2})}</div>
                    </div>
                  ))}
              </>
            )}
            
            <div className="payment-row total">
              <div className="col-description">Balance Due</div>
              <div className="col-amount">{Number(balance || 0).toLocaleString('en-US', {minimumFractionDigits: 2})}</div>
            </div>
          </div>
        </div>

        {/* Luxury Footer */}
        <div className="luxury-footer">
          <div className="footer-terms">
            <h4>TERMS & CONDITIONS</h4>
            <ol>
              <li>Advance Payment should be made in order to confirm the booking date and 80% of the full payment should be settled on the Event Date.</li>
              <li>The Advance payment is non-refundable.</li>
              <li>Transport cost will be charged for all the Function Outside Colombo & Piliyandala suburbs.</li>
              <li>Kindly note that, The Limited number of shoots publish in social media depend on our choice.</li>
            </ol>
          </div>
          
          <div className="footer-signatures">
            <div className="agreement-text">
              <span>I agreed to above mentioned terms & conditions.</span>
            </div>
            <div className="signature-row">
              <div className="signature-box">
                <div className="signature-line"></div>
                <p>Client Signature</p>
              </div>
              <div className="signature-box">
                <div className="signature-line"></div>
                <p>Authorized Signature</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PBQuot;